import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import {
  Force_Logout_selected_User,
  Update_One_user_Main_data_Action,
} from '../../Redux/Actions/AuthAction';
import { Notify } from '../../Utility/Notify';

/* ─── Icons ──────────────────────────────────────────────────────────────── */
const IconX = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
    <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
  </svg>
);
const IconWarning = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
    <line x1="12" y1="9" x2="12" y2="13"/>
    <line x1="12" y1="17" x2="12.01" y2="17"/>
  </svg>
);
const IconDeactivate = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
    <circle cx="12" cy="12" r="10"/><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/>
  </svg>
);
const IconActivate = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);
const IconDelete = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
    <polyline points="3 6 5 6 21 6"/>
    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>
    <path d="M10 11v6M14 11v6"/>
    <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>
  </svg>
);
const IconLogout = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
    <polyline points="16 17 21 12 16 7"/>
    <line x1="21" y1="12" x2="9" y2="12"/>
  </svg>
);

/* ─── Confirm Modal ──────────────────────────────────────────────────────── */
const ConfirmModal = ({ isDark, title, message, confirmLabel, confirmColor, confirmShadow, icon, onClose, onConfirm, loading }) => {
  const { createPortal } = require('react-dom');

  const gradients = {
    red:    'linear-gradient(135deg,#ef4444,#dc2626)',
    green:  'linear-gradient(135deg,#22c55e,#16a34a)',
    orange: 'linear-gradient(135deg,#f59e0b,#d97706)',
  };
  const iconBg = {
    red:    isDark ? 'rgba(239,68,68,0.12)'  : 'rgba(239,68,68,0.08)',
    green:  isDark ? 'rgba(34,197,94,0.12)'  : 'rgba(34,197,94,0.08)',
    orange: isDark ? 'rgba(245,158,11,0.12)' : 'rgba(245,158,11,0.08)',
  };
  const iconBorder = {
    red:    isDark ? 'rgba(239,68,68,0.25)'  : 'rgba(239,68,68,0.18)',
    green:  isDark ? 'rgba(34,197,94,0.25)'  : 'rgba(34,197,94,0.18)',
    orange: isDark ? 'rgba(245,158,11,0.25)' : 'rgba(245,158,11,0.18)',
  };
  const iconColor = { red:'#ef4444', green:'#22c55e', orange:'#f59e0b' };

  return createPortal(
    <>
      <style>{`
        @keyframes ua-fade  { from{opacity:0} to{opacity:1} }
        @keyframes ua-slide { from{opacity:0;transform:translateY(16px) scale(0.97)} to{opacity:1;transform:none} }
        @keyframes ua-spin  { to{transform:rotate(360deg)} }
      `}</style>
      <div
        onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
        style={{
          position:'fixed', inset:0, zIndex:40000,
          backgroundColor:'rgba(0,0,0,0.55)', backdropFilter:'blur(4px)',
          display:'flex', alignItems:'center', justifyContent:'center', padding:20,
          animation:'ua-fade 0.18s ease',
        }}
      >
        <div style={{
          width:'100%', maxWidth:420, borderRadius:20, overflow:'hidden',
          backgroundColor: isDark ? '#1a1d2e' : '#ffffff',
          border:`1px solid ${isDark ? '#2a2f45' : '#e8eaf0'}`,
          boxShadow: isDark ? '0 24px 60px rgba(0,0,0,0.6)' : '0 20px 60px rgba(0,0,0,0.15)',
          animation:'ua-slide 0.22s cubic-bezier(0.34,1.56,0.64,1)',
          fontFamily:"'DM Sans','Segoe UI',sans-serif",
        }}>

          {/* Header */}
          <div style={{ padding:'16px 20px', borderBottom:`1px solid ${isDark?'#2a2f45':'#f1f3f8'}`, display:'flex', alignItems:'center', justifyContent:'space-between' }}>
            <span style={{ fontSize:12, fontWeight:700, letterSpacing:'0.07em', textTransform:'uppercase', color:isDark?'#4b5563':'#94a3b8' }}>
              Confirm Action
            </span>
            <button
              onClick={onClose}
              style={{ display:'flex', alignItems:'center', justifyContent:'center', width:28, height:28, borderRadius:8, border:'none', cursor:'pointer', background:isDark?'rgba(255,255,255,0.06)':'#f1f5f9', color:isDark?'#9ca3af':'#6b7280', transition:'all 0.15s' }}
              onMouseEnter={(e) => { e.currentTarget.style.background=isDark?'rgba(255,255,255,0.12)':'#e2e8f0'; }}
              onMouseLeave={(e) => { e.currentTarget.style.background=isDark?'rgba(255,255,255,0.06)':'#f1f5f9'; }}
            >
              <IconX />
            </button>
          </div>

          {/* Body */}
          <div style={{ padding:'28px 24px 24px', textAlign:'center' }}>
            {/* Icon */}
            <div style={{ width:64, height:64, borderRadius:18, margin:'0 auto 20px', background:iconBg[confirmColor], border:`1px solid ${iconBorder[confirmColor]}`, display:'flex', alignItems:'center', justifyContent:'center', color:iconColor[confirmColor] }}>
              <IconWarning />
            </div>

            <h3 style={{ fontSize:17, fontWeight:800, margin:'0 0 8px', color:isDark?'#f9fafb':'#111827', letterSpacing:'-0.3px' }}>
              {title}
            </h3>
            <p style={{ fontSize:13, color:isDark?'#6b7280':'#9ca3af', margin:'0 0 28px', lineHeight:1.6 }}>
              {message}
            </p>

            {/* Buttons */}
            <div style={{ display:'flex', gap:10 }}>
              <button
                onClick={onClose} disabled={loading}
                style={{ flex:1, padding:11, borderRadius:12, border:'none', cursor:'pointer', fontSize:13, fontWeight:700, fontFamily:"'DM Sans',sans-serif", background:isDark?'rgba(255,255,255,0.07)':'#f1f5f9', color:isDark?'#d1d5db':'#374151', transition:'all 0.15s' }}
                onMouseEnter={(e) => { e.currentTarget.style.background=isDark?'rgba(255,255,255,0.12)':'#e2e8f0'; }}
                onMouseLeave={(e) => { e.currentTarget.style.background=isDark?'rgba(255,255,255,0.07)':'#f1f5f9'; }}
              >
                Cancel
              </button>
              <button
                onClick={onConfirm} disabled={loading}
                style={{ flex:1, padding:11, borderRadius:12, border:'none', cursor:loading?'not-allowed':'pointer', fontSize:13, fontWeight:700, fontFamily:"'DM Sans',sans-serif", background:loading?'rgba(100,100,100,0.3)':gradients[confirmColor], color:'#fff', transition:'all 0.2s', boxShadow:loading?'none':confirmShadow, display:'flex', alignItems:'center', justifyContent:'center', gap:8, opacity:loading?0.75:1 }}
                onMouseEnter={(e) => { if(!loading) e.currentTarget.style.transform='translateY(-1px)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.transform='translateY(0)'; }}
              >
                {loading ? (
                  <>
                    <span style={{ width:14, height:14, borderRadius:'50%', border:'2px solid rgba(255,255,255,0.3)', borderTopColor:'#fff', animation:'ua-spin 0.7s linear infinite', display:'inline-block' }} />
                    Please wait…
                  </>
                ) : (
                  <>{icon}{confirmLabel}</>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>,
    document.body
  );
};

/* ─── Main Component ─────────────────────────────────────────────────────── */
/* ─── Main Component ─────────────────────────────────────────────────────── */
export const UsersActions = ({ userid, getallusers }) => {
  const dispatch = useDispatch();
  const theme    = useTheme();
  const isDark   = theme.palette.mode === 'dark';

  const [modal,   setModal]   = useState(null);
  const [loading, setLoading] = useState(false);

  const closeModal = () => setModal(null);

  const run = async (fn, successMsg) => {
    setLoading(true);
    try {
      await fn();
      Notify('success', successMsg, 'success');
      closeModal();
      getallusers();
    } catch {
      Notify('error', 'Something went wrong', 'error');
    } finally {
      setLoading(false);
    }
  };

  const handlers = {
    deactivate: () => run(
      () => dispatch(Update_One_user_Main_data_Action(userid, { active: false })),
      'User deactivated successfully'
    ),
    delete: () => run(
      () => dispatch(Update_One_user_Main_data_Action(userid, { isactivefordelete: false, active: false })),
      'User deleted successfully'
    ),
    activate: () => run(
      () => dispatch(Update_One_user_Main_data_Action(userid, { active: true })),
      'User activated successfully'
    ),
    logout: () => run(
      () => dispatch(Force_Logout_selected_User(userid)),
      'User logged out successfully'
    ),
  };

  const MODALS = {
    deactivate: {
      title:         'Deactivate this user?',
      message:       'The user will be deactivated and won\'t be able to log in. You can reactivate them later.',
      confirmLabel:  'Deactivate',
      confirmColor:  'orange',
      confirmShadow: '0 4px 14px rgba(245,158,11,0.4)',
      iconType:      'deactivate',
    },
    delete: {
      title:         'Delete this user?',
      message:       'The user will be permanently removed from the system. This action cannot be undone.',
      confirmLabel:  'Yes, Delete',
      confirmColor:  'red',
      confirmShadow: '0 4px 14px rgba(239,68,68,0.4)',
      iconType:      'delete',
    },
    activate: {
      title:         'Activate this user?',
      message:       'The user will regain access to the system and can log in again.',
      confirmLabel:  'Yes, Activate',
      confirmColor:  'green',
      confirmShadow: '0 4px 14px rgba(34,197,94,0.4)',
      iconType:      'activate',
    },
    logout: {
      title:         'Log out this user?',
      message:       'The user will be immediately logged out of all active sessions.',
      confirmLabel:  'Yes, Log Out',
      confirmColor:  'red',
      confirmShadow: '0 4px 14px rgba(239,68,68,0.4)',
      iconType:      'logout',
    },
  };

  const actionBtn = (color, bg, border) => ({
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
    width: 28, height: 28, borderRadius: 7, border: '1px solid ' + border,
    cursor: 'pointer', background: bg, transition: 'all 0.18s', flexShrink: 0,
    color,
  });

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>

        <button
          title="Deactivate User"
          style={actionBtn('#f59e0b', isDark ? 'rgba(245,158,11,0.07)' : 'rgba(245,158,11,0.06)', isDark ? 'rgba(245,158,11,0.25)' : 'rgba(245,158,11,0.2)')}
          onClick={() => setModal('deactivate')}
          onMouseEnter={(e) => { e.currentTarget.style.background = isDark ? 'rgba(245,158,11,0.18)' : 'rgba(245,158,11,0.12)'; }}
          onMouseLeave={(e) => { e.currentTarget.style.background = isDark ? 'rgba(245,158,11,0.07)' : 'rgba(245,158,11,0.06)'; }}
        >
          <IconDeactivate />
        </button>

        <button
          title="Activate User"
          style={actionBtn('#22c55e', isDark ? 'rgba(34,197,94,0.07)' : 'rgba(34,197,94,0.06)', isDark ? 'rgba(34,197,94,0.25)' : 'rgba(34,197,94,0.2)')}
          onClick={() => setModal('activate')}
          onMouseEnter={(e) => { e.currentTarget.style.background = isDark ? 'rgba(34,197,94,0.18)' : 'rgba(34,197,94,0.12)'; }}
          onMouseLeave={(e) => { e.currentTarget.style.background = isDark ? 'rgba(34,197,94,0.07)' : 'rgba(34,197,94,0.06)'; }}
        >
          <IconActivate />
        </button>

        <button
          title="Delete User"
          style={actionBtn('#ef4444', isDark ? 'rgba(239,68,68,0.07)' : 'rgba(239,68,68,0.06)', isDark ? 'rgba(239,68,68,0.25)' : 'rgba(239,68,68,0.2)')}
          onClick={() => setModal('delete')}
          onMouseEnter={(e) => { e.currentTarget.style.background = isDark ? 'rgba(239,68,68,0.18)' : 'rgba(239,68,68,0.12)'; }}
          onMouseLeave={(e) => { e.currentTarget.style.background = isDark ? 'rgba(239,68,68,0.07)' : 'rgba(239,68,68,0.06)'; }}
        >
          <IconDelete />
        </button>

        <button
          title="Log Out User"
          style={actionBtn(isDark ? '#9ca3af' : '#64748b', 'transparent', isDark ? '#252d45' : '#e2e8f0')}
          onClick={() => setModal('logout')}
          onMouseEnter={(e) => { e.currentTarget.style.background = isDark ? 'rgba(255,255,255,0.07)' : '#f1f5f9'; }}
          onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
        >
          <IconLogout />
        </button>
      </div>

      {modal && (
        <ConfirmModal
          isDark={isDark}
          {...MODALS[modal]}
          loading={loading}
          onClose={closeModal}
          onConfirm={handlers[modal]}
        />
      )}
    </>
  );
};